import CalculatorAdvancedView from './CalculatorAdvancedView'

export default CalculatorAdvancedView
